import React from 'react';
import {Message} from '../index';

export default () => {
    return (<div className="maintenance-wrapper">
        <div>
            <p><Message code="epic.esport.hyperwallet.maintenance.message1" /></p>
            <p><Message code="epic.esport.hyperwallet.maintenance.message2" /></p>
        </div>
    </div>);
};
